<template>
  <aside id="logo-sidebar"
      class="w-72 h-screen pt-2 transition-transform -translate-x-full bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700 shadow"
      aria-label="Sidebar">
      <div class="h-full px-3 pb-36 overflow-y-auto bg-white dark:bg-gray-800">
          <ul class="space-y-2 font-medium">
              <!-- <SidebarSimpleLink label="Dashboard" icon="fa-solid fa-home" to="dashboard" /> -->

              <div v-if="menusAuthorized.length">
                <div v-for="(menuAuthorized, index) in menusAuthorized" :key="index">
                  
                  <SidebarSimpleLink v-if="!menuAuthorized.isParent" :label="menuAuthorized.name" :icon="menuAuthorized.icon" :to="menuAuthorized.route" />

                  <SidebarDropdownLinks v-else :label="menuAuthorized.name" :icon="menuAuthorized.icon" :links="menuAuthorized.children" />

                </div>
              </div>

          </ul>
      </div>
  </aside>
</template>

<script>
  import SidebarSimpleLink from '@/shared/components/Sidebar/v2/SidebarSimpleLink.vue';
  import SidebarDropdownLinks from '@/shared/components/Sidebar/v2/SidebarDropdownLinks.vue';
  import { mapGetters } from 'vuex';
  
  export default {
    components: {
      SidebarSimpleLink,
      SidebarDropdownLinks
    },
    data() {
      return {
        menusAuthorized: []
      }
    }, 
    computed: {
      ...mapGetters({
        'menuShared': 'shared/menus',
        'menuAuth': 'auth/userMenus',
      })
    },
    methods: {
      menuInit() {
        const menusGeneral = this.menuShared
        const menusUser = this.menuAuth

        for (let index = 0; index < menusGeneral.length; index++) {
          const menuGeneral = menusGeneral[index];

          if (menuGeneral.isParent) {
            
            const childrenAuthorized = []

            for (let a = 0; a < menuGeneral.children.length; a++) {
              const children = menuGeneral.children[a];
              
              for (let s = 0; s < menusUser.length; s++) {
                const menuUser = menusUser[s];

                if (menuUser == children.route) {
                  childrenAuthorized.push({ label: children.name, to: children.route, isRouterLink: true})
                }
                
              }

            }

            if (childrenAuthorized.length) {
              this.menusAuthorized.push({ isParent: menuGeneral.isParent, children: childrenAuthorized, icon: menuGeneral.icon, name: menuGeneral.name })
            }

          } else {

            for (let s = 0; s < menusUser.length; s++) {
              const menuUser = menusUser[s];

              if (menuUser == menuGeneral.route) {
                this.menusAuthorized.push(menuGeneral)
              }
              
            }

          }
          
        }
      }
    },
    mounted() {
      this.menuInit()
    }
  }
</script>